import { isValid, parse } from 'date-fns';
import * as locale from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

export function anonymizeName(name: string) {
  const newName = name.charAt(0) + name.slice(1).replace(/[a-zA-ZÀ-ÿ]/g, '*');
  return newName;
}

export function AnonymizeDate(patientDate: string) {
  const { i18n } = useTranslation();

  const validDate = isValid(
    parse(patientDate, 'P', new Date(), {
      locale: locale[i18n.language.replace('-', '') as keyof typeof locale],
    }),
  );

  if (!validDate) {
    return patientDate;
  }

  const newDate = new Date(patientDate);
  const newDateAnon = newDate.toLocaleDateString(i18n.language);
  return newDateAnon.replace(/^(\w{2})/, '**');
}
